import {create} from 'zustand';
import {addOnApi} from '../services/api/addOnApi';

export const useAddOnStore = create((set) => ({
  addOns: [],
  isLoading: false,

  fetchAddOns: async () => {
    set({isLoading: true});
    try {
      const response = await addOnApi.list();
      set({addOns: response.data.data});
    } finally {
      set({isLoading: false});
    }
  },

  createAddOn: async (data) => {
    const response = await addOnApi.create(data);
    const newItem = response.data.data;
    set(state => ({addOns: [...state.addOns, newItem]}));
    return newItem;
  },

  updateAddOn: async (id, data) => {
    const response = await addOnApi.update(id, data);
    const updated = response.data.data;
    set(state => ({
      addOns: state.addOns.map(a => (a.id === id ? updated : a)),
    }));
    return updated;
  },

  deleteAddOn: async (id) => {
    await addOnApi.remove(id);
    set(state => ({
      addOns: state.addOns.filter(a => a.id !== id),
    }));
  },
}));
